<template>
  <header class="sal-header">
    <div class="sal-header-brand">
      {{ brand }}
    </div>

    <div class="sal-stepper" aria-label="Progreso del formulario">
      <span
        v-for="n in totalSteps"
        :key="n"
        class="sal-stepper-dot"
        :class="{ 'is-active': n === step, 'is-done': n < step }"
      ></span>
    </div>
  </header>
</template>

<script setup>
defineProps({
  brand: {
    type: String,
    default: 'SCRAP ALMACÉN Y LASER'
  },
  step: {
    type: Number,
    required: true
  },
  totalSteps: {
    type: Number,
    default: 5
  }
})
</script>
